import React, {useContext, useEffect, useMemo, useState} from 'react';
import {IconButton} from '@mui/material';
import {Close} from '@mui/icons-material';
import './WidgetPopupV2.scss';
import WelcomeMessagePopup from './CampaignPopup/WelcomeMessagePopup';
import SubscribeNewsletterPopup from './CampaignPopup/SubscribeNewsletterPopup';
import CartBoosterPopup from './CampaignPopup/CartBoosterPopup';
import {CAMPAIGN_TEMPLATE_ID} from '@assets/const/campaignTemplate';
import {FloatButtonContext} from '@assets/contexts/floatButtonContext';
import ProductRecommendationPopup from './CampaignPopup/ProductRecommendationPopup';
import {DEFAULT_MESSAGE_TYPE} from '@assets/helpers/campaign/defaultCampaignSetting';
import {trackCampaignShow, trackCampaignClick} from '@assets/helpers/campaignTracking';

const useMuiSx = () => ({
  card: {
    backgroundColor: '#f6f6f6',
    borderRadius: '8px',
    p: '8px'
  },
  inputRoot: {
    backgroundColor: '#f4f4f4',
    borderRadius: '8px',
    pl: '10px',
    pr: '10px',
    height: '40px'
  },
  input: {
    p: '0',
    fontSize: '14px',
    lineHeight: '40px',
    color: '#737373'
  },
  iconButton: {
    p: '8px',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
});

export default function WidgetPopupV2({
  campaign,
  handleClick,
  handleClosePopups,
  floatBtnPosition
}) {
  const {i18nCampaign, isPreview} = useContext(FloatButtonContext);
  const animationClass = floatBtnPosition?.includes('right')
    ? 'slide-in-bottom-right'
    : 'slide-in-bottom-left';
  const sx = useMuiSx();
  const [fetchedRecommendedProduct, setFetchedRecommendedProduct] = useState(false);

  const renderContent = () => {
    switch (campaign?.templateId) {
      case CAMPAIGN_TEMPLATE_ID.WELCOME_VISITORS:
        return <WelcomeMessagePopup campaign={campaign} i18nCampaign={i18nCampaign} sx={sx} />;
      case CAMPAIGN_TEMPLATE_ID.SUBSCRIBE_NEWSLETTER:
        return <SubscribeNewsletterPopup campaign={campaign} i18nCampaign={i18nCampaign} sx={sx} />;
      case CAMPAIGN_TEMPLATE_ID.PRODUCT_RECOMMENDATION:
        return (
          <ProductRecommendationPopup
            campaign={campaign}
            i18nCampaign={i18nCampaign}
            handleClick={handleClick}
            setFetchedRecommendedProduct={setFetchedRecommendedProduct}
            sx={sx}
          />
        );
      case CAMPAIGN_TEMPLATE_ID.CART_BOOSTER:
        return (
          <CartBoosterPopup
            campaign={campaign}
            i18nCampaign={i18nCampaign}
            setFetchedRecommendedProduct={setFetchedRecommendedProduct}
            handleClick={handleClick}
            sx={sx}
          />
        );
      default:
        return null;
    }
  };

  const filterCampaigns = [
    CAMPAIGN_TEMPLATE_ID.PRODUCT_RECOMMENDATION,
    CAMPAIGN_TEMPLATE_ID.CART_BOOSTER
  ];

  const showPopup = useMemo(() => {
    const isProductRecommendationCampaign =
      campaign?.templateId === CAMPAIGN_TEMPLATE_ID.PRODUCT_RECOMMENDATION ||
      (campaign?.templateId === CAMPAIGN_TEMPLATE_ID.CART_BOOSTER &&
        campaign?.message?.type === DEFAULT_MESSAGE_TYPE.PRODUCT_RECOMMENDATION);
    if (isProductRecommendationCampaign && !isPreview && !fetchedRecommendedProduct) {
      return false;
    }
    return true;
  }, [fetchedRecommendedProduct, campaign?.templateId]);

  const handleClickCampaign = () => {
    if (campaign?.id && !isPreview) trackCampaignClick(campaign.id);
    if (!filterCampaigns.includes(campaign?.templateId)) handleClick();
  };

  useEffect(() => {
    if (campaign?.id && !isPreview) trackCampaignShow(campaign.id);
  }, [campaign]);

  return (
    <div
      className={`Avada-FaqsWelcomePopup__Container ${animationClass}`}
      style={{backgroundColor: '#FFFFFF', display: showPopup ? 'block' : 'none'}}
      onClick={handleClickCampaign}
    >
      <IconButton
        onClick={handleClosePopups}
        style={{
          width: 20,
          height: 20,
          position: 'absolute',
          right: 5,
          top: 4,
          zIndex: 2,
          borderRadius: '4px'
        }}
        aria-label="Close popup"
        aria-labelledby="close-button-popup"
      >
        <Close />
      </IconButton>
      {renderContent()}
    </div>
  );
}
